import React, { useState } from "react";
import "./EmployeeAuth.css";

function EmployeeAuth() {
  const [isSignup, setIsSignup] = useState(true);

  return (
    <div className="employee-auth-page">
      <div className="employee-auth-box">
        <h2>Employee {isSignup ? "Sign Up" : "Sign In"}</h2>

        <form>
          <input type="email" placeholder="Email" required />
          <input type="password" placeholder="Password" required />

          {isSignup && (
            <>
              <input type="text" placeholder="Employee ID" required />
              <input type="text" placeholder="Department" required />
            </>
          )}

          <button type="submit">{isSignup ? "Sign Up" : "Sign In"}</button>
        </form>

        <p onClick={() => setIsSignup(!isSignup)} className="employee-toggle-link">
          {isSignup ? "Already have an account? Sign In" : "Don’t have an account? Sign Up"}
        </p>
      </div>
    </div>
  );
}

export default EmployeeAuth;
